/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components";

const InvoiceErrorsModal = ({
	show,
	onAcknowledge,
	invoiceErrors
}) => {
	const { lang } = global;

	const closeModal = () => { };
	const onApply = () => { };

	return (
		<Modal
			show={show}
			onHide={onAcknowledge}
			id="invoice-conflicts-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Invoice Errors")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row form-group">
					<div className="col-xs-12">
						<p>
							{lang.t("The following invoices selected to send have errors:")}
							<br />
						</p>
						{invoiceErrors.length > 0 && invoiceErrors.map(message => <li>{message}</li>)}
					</div>
					<div className="col-xs-12">
						<p>
							<br />
							{lang.t("To continue with the sending process, fix these invoices individually, after errors are resolved invoices can be successfully sent")}
						</p>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onAcknowledge}
				>
					{lang.t("Acknowledge")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

InvoiceErrorsModal.propTypes = {
	show: PropTypes.bool,
	onAcknowledge: PropTypes.func,
	invoiceErrors: PropTypes.array,
};

InvoiceErrorsModal.defaultProps = {
	show: false,
	onAcknowledge: () => { },
	invoiceErrors: [],
};

export default InvoiceErrorsModal;
